"use client";

import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";

import styles from "./article.module.scss";
import services from "@/store/services";

function Article(props) {
  const { data, updateProgress, isAccessable, _id } = props;
  const { isEnrolled } = useSelector((state) => state.video);
  const [isCompleted, setIsCompleted] = useState(false);
  const articleDetails = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    if (articleDetails.current) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = data;
      const elements = tempDiv.querySelectorAll("[style]");
      elements.forEach((el) => el.removeAttribute("style"));
      articleDetails.current.innerHTML = tempDiv.innerHTML;
    }
  }, [data]);

  useEffect(() => {
    if (isEnrolled) {
      const status = isEnrolled?.seenContents?.some(
        (vd) => vd.entityId === _id
      );
      setIsCompleted(status);
    }
  }, [isEnrolled]);

  const handleComplete = () => {
    if (isEnrolled) {
      updateProgress();
      setIsCompleted(true);
    } else {
      dispatch(services.warningAlert(`You're not enrolled into this course!`));
    }
  };

  return (
    <section
      className={styles.container}
      style={
        isAccessable?.status === "locked"
          ? { backgroundColor: "#353739" }
          : null
      }
    >
      {isAccessable && isAccessable.status === "locked" ? (
        <>
          <div className={styles.accessDenied}>
            <Icon icon="ph:file-x-fill" className={styles.icon} />
            <h3>{isAccessable.message}</h3>
          </div>
        </>
      ) : (
        <>
          <div ref={articleDetails}></div>
          <div className={styles["read-checkbox"]}>
            <input
              type="checkbox"
              checked={isCompleted}
              onChange={handleComplete}
            />
            Mark as completed
          </div>
        </>
      )}
    </section>
  );
}

export default Article;
